"use strict";
/*
 * Created on 03 19 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Converter of {@link FamilyCreatedDTO}.
 *
 * @author JMe
 */


var FamilyCreatedDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(FamilyCreatedDTOConverter, _DataObjectConverter_);

  function FamilyCreatedDTOConverter() {
    _classCallCheck(this, FamilyCreatedDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(FamilyCreatedDTOConverter).apply(this, arguments));
  }

  return FamilyCreatedDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.FamilyCreatedDTOConverter = FamilyCreatedDTOConverter;